import React from "react";
import PatientContact from "./PatientContact";
import SelectedPatient from "./SelectedPatient";
const SlugListModal = ({
  onHide,
  setSearchedPatient,
  selectedPatients,
  handleNewContact,
  removeSelectedPatient,
  handleCheckAllPatients,
  handleCheckPatientContact,
  patientsFound,
  searchedPatient,
  newNumber,
  setNewNumber,
  notFound,
  checkedAll,
  filteredPatients,
  updateFlag,
}) => {
  return (
    <>
      <div className="slugmessage-modal-wrapper container list-drawer py-3 px-2 px-sm-2">
        <div className="px-2">
          <span style={{ fontSize: "25px" }}>Select Contact</span>{" "}
          <span
            className="float-right cursor-pointer"
            onClick={onHide}
            style={{ fontSize: "1rem" }}
          >
            Close <i className="fa fa-times" aria-hidden="true"></i>
          </span>
        </div>

        <div className="container py-2 px-0 px-md-2 pb-1">
          <div className=" my-2">
            <>
              <div
                className="shadow container search-box"
                style={{ width: "auto" }}
              >
                <input
                  type="text"
                  className="search-txt"
                  value={searchedPatient}
                  placeholder="Enter Number or Search for a number"
                  onChange={(e) => setSearchedPatient(e.target.value)}
                  onKeyPress={(e) => {
                    if (newNumber) {
                      setNewNumber(false);
                    }
                    if (e.key === "Enter") {
                      let count = 0;
                      if (selectedPatients.length > 0) {
                        for (let i = 0; i < selectedPatients.length; i++) {
                          if (
                            selectedPatients[i].phone ===
                            "+91" + e.target.value
                          ) {
                            count = 1;
                            break;
                          }
                        }
                        if (count === 1) {
                          return;
                        } else {
                          handleNewContact(e);
                        }
                      } else {
                        handleNewContact(e);
                      }
                    }
                  }}
                />
                <span className="search-btn">
                  <i className="fa fa-search"></i>
                </span>
              </div>

              <small
                className="text-danger ml-3 mt-2">
                {notFound ? notFound : "Press Enter after adding a new number"}
              </small>
              {selectedPatients.length > 0 ? (
                <div className="m-2">
                  <hr className="my-1" />
                  <div className="selected-contacts py-2 slug-contact-list  boder-0">
                    {selectedPatients.map((sp) => (
                      <SelectedPatient
                        key={sp.id}
                        {...sp}
                        removeSelectedPatient={removeSelectedPatient}
                      />
                    ))}
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="select-all my-2">
                <input
                  type="checkbox"
                  id="select-all"
                  checked={checkedAll}
                  onChange={handleCheckAllPatients}
                />
                <label htmlFor="select-all" className="m-3">
                  Select All Contacts
                </label>
              </div>
              {filteredPatients.length > 0 ? (
                <div
                  className="contact-list pb-1 container_scroll"
                  style={{
                    minHeight: "21vh",
                    maxHeight: "21vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  {filteredPatients.map((patient, index) => (
                    <PatientContact
                      key={patient.id}
                      {...patient}
                      handleCheckPatientContact={handleCheckPatientContact}
                    />
                  ))}
                </div>
              ) : (
                <>
                  <p className="text-center text-danger">Not Patient Found</p>
                </>
              )}
            </>
          </div>
        </div>
        <button
          type="button"
          className="btn border share-button rounded-pill ml-3 mt-1 mb-1"
          onClick={patientsFound}
          disabled={selectedPatients.length > 0 ? false : true}
        >
          {updateFlag ? <>Update Contact</> : <>Select Contact</>}
        </button>
        {updateFlag ? (
          <>
            <p style={{ color: "red", paddingLeft: "1.87rem" }}>
              Note: To update the list of recipients please click Update Contact
            </p>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
export default SlugListModal;
